import React from "react";
import {
    Navbar,
    MobileNav,
    Typography,
    Button,
    IconButton,

} from "@material-tailwind/react";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import jwt_decode from "jwt-decode";

export function Menu() {
    const [openNav, setOpenNav] = React.useState(false);
    const navigate = useNavigate();

    React.useEffect(() => {
        window.addEventListener(
            "resize",
            () => window.innerWidth >= 960 && setOpenNav(false),
        );
    }, []);

    const checkToken = () => {
        const token = localStorage.getItem("token");
        try {
            // Dekodiramo token i proveravamo datum isteka
            const decodedToken = jwt_decode(token);
            const currentTime = Date.now() / 1000; // Sadašnji timestamp u sekundama

            if (decodedToken.exp < currentTime) {
                console.log("🚨 Token je istekao! Brišem token i preusmeravam na login...");
                localStorage.removeItem("token");
                navigate("/login");
                return false;
            }
            return true;
        } catch (error) {
            console.log("🚨 Token nije validan! Brišem token i preusmeravam na login...");
            localStorage.removeItem("token");
            navigate("/login");
            return false;
        }
    };

    const handleLogout = async () => {
        // Pre nego što nastavi sa logout-om, proverite da li je token validan
        const isTokenValid = checkToken();
        if (!isTokenValid) {
            // Ako token nije validan, ne nastavljamo dalje
            return;
        }

        const token = localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const API_URL = process.env.REACT_APP_API_URL;

        try {
            await axios.post(`${API_URL}/auth/logout`, null, config);
            localStorage.removeItem("token");
            sessionStorage.setItem("scrollPosition", window.scrollY.toString());
            navigate("/login");
        } catch (error) {
            console.error("Greška pri logout-u:", error);
        }
    };

    const navigateWithTokenCheck = (path, event) => {
        event.preventDefault(); // Sprečava default navigaciju
        const isTokenValid = checkToken();  // Proveravamo token
        if (isTokenValid) {
            navigate(path);  // Ako je token validan, preusmeravamo na željeni put
        }
    };


    const navList = (
        <ul className="mt-2 mb-4 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
            <Link to="/" onClick={(event) => navigateWithTokenCheck("/", event)}>
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        Početna
                    </span>
                </Typography>
            </Link>
            <Link to="/o_nama" onClick={(event) => navigateWithTokenCheck("/o_nama", event)}>
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        O nama
                    </span>
                </Typography>
            </Link>
            <Link to="/saveti" onClick={(event) => navigateWithTokenCheck("/saveti", event)}>
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        Saveti
                    </span>
                </Typography>
            </Link>
            <Link to="/kontakt" onClick={(event) => navigateWithTokenCheck("/kontakt", event)}>
                <Typography
                    as="li"
                    variant="small"
                    color="blue-gray"
                    className="p-1 font-normal"
                >
                    <span className="flex items-center">
                        Kontakt
                    </span>
                </Typography>
            </Link>
        </ul>
    );

    return (
        <div className="w-full lg:w-[80%] mx-auto max-h-[768px] no-print">
            <Navbar className="sticky top-0 z-10 h-max max-w-full px-4 py-3 lg:px-8 lg:py-4 rounded-lg shadow-lg backdrop-blur-md bg-white">
                <div className="flex items-center justify-between text-blue-gray-900">
                    <Link to="/">
                        <div className="flex items-center gap-2">
                            <span className="cursor-pointer py-1.5">
                                <img
                                    src="/transparent logo solo.png"
                                    alt="Smart Service System Logo"
                                    className="h-6 w-auto"
                                />
                            </span>
                            <Typography
                                className="cursor-pointer py-2 font-semibold text-gray-900 ml-2 text-lg tracking-tight leading-tight rounded-full px-6"
                            >
                                Smart Service System
                            </Typography>
                        </div>
                    </Link>
                    <div className="flex items-center gap-4">
                        <div className="mr-4 hidden lg:block">{navList}</div>
                        <div className="flex items-center gap-x-1">
                            <Link to="/home" onClick={(event) => navigateWithTokenCheck("/home", event)}>
                                <Button
                                    variant="text"
                                    size="sm"
                                    className="hidden lg:inline-block hover:bg-gray-100 rounded-full"
                                >
                                    <span className="text-gray-900">Moj nalog</span>
                                </Button>
                            </Link>
                            <Button
                                size="sm"
                                className="hidden lg:inline-block bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:from-blue-400 hover:via-blue-500 hover:to-blue-600 text-white rounded-full"
                                onClick={handleLogout} // Ovdje pozivamo handleLogout prilikom klika
                            >
                                <span>Odjavite se</span>
                            </Button>
                        </div>
                        <IconButton
                            variant="text"
                            className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
                            ripple={false}
                            onClick={() => setOpenNav(!openNav)}
                        >
                            {openNav ? (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    className="h-6 w-6"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M4 6h16M4 12h16M4 18h16"
                                    />
                                </svg>
                            )}
                        </IconButton>
                    </div>
                </div>
                <MobileNav open={openNav}>
                    {navList}
                    <div className="flex items-center gap-x-1">
                        <Link to="/home">
                            <Button fullWidth variant="text" size="sm" className="rounded-full">
                                <span className="text-gray-900">Moj nalog</span>
                            </Button>
                        </Link>
                        <Button onClick={handleLogout} fullWidth variant="gradient" size="sm" className=" bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:from-blue-400 hover:via-blue-500 hover:to-blue-600 text-white rounded-full">
                            <span className="text-white">Odjavite se</span>
                        </Button>
                    </div>
                </MobileNav>
            </Navbar>
        </div>
    );
}